import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable } from 'rxjs';
import { OrderLineApiModel } from 'app/models/order-line-api.model';
import { MwPayloadModel } from 'app/models/payload.model';

import { MwLoadOptions } from 'app/models/load-options.model';
import { MwLoadOptionsService } from './utils/load-options.service';

@Injectable({ providedIn: 'root' })
export class MwOrderLinesApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {}

  private apiEndpoint = '/transport/v1/Companies/{companyId}/OrderLines';

  getOrderLines(
    options?: MwLoadOptions
  ): Observable<MwPayloadModel<OrderLineApiModel[]>> {
    let query = options ? this.loadOptionsService.buildQuery(options) : '';
    query = query.length ? `?${query}` : '';
    return this.http.authGet<MwPayloadModel<OrderLineApiModel[]>>(
      `${this.apiEndpoint}${query}`
    );
  }

  createOrderLine(orderLine: OrderLineApiModel): Observable<OrderLineApiModel> {
    return this.http.authPost<OrderLineApiModel>(`${this.apiEndpoint}`, {
      body: orderLine,
    });
  }

  updateOrderLine(orderLine: OrderLineApiModel): Observable<OrderLineApiModel> {
    return this.http.authPut<OrderLineApiModel>(`${this.apiEndpoint}`, {
      body: orderLine,
    });
  }

  deleteOrderLine(OrderLine: OrderLineApiModel): Observable<any> {
    return this.http.authDelete<OrderLineApiModel>(`${this.apiEndpoint}`, {
      body: OrderLine,
    });
  }

  deleteOrderLinesList(orderLines: OrderLineApiModel[]): Observable<any> {
    return this.http.authDelete<any>(`${this.apiEndpoint}/All`, {
      body: orderLines,
    });
  }

  generateOrderLinesAssignments(
    orderLine: OrderLineApiModel,
    quantity: number
  ): Observable<any> {
    return this.http.authPost<OrderLineApiModel>(
      `${this.apiEndpoint}/GenerateAssignments/${quantity}`,
      {
        body: orderLine,
      }
    );
  }
}
